<template>
    <div class="bonusomat-modal__quest-games-scroll-wrap">
        <div class="bonusomat-modal__quest-games">
            <div
                class="bonusomat-board__modal__game"
                v-for="(game, gameIndex) in activeTaskGames"
                :key="game.id"
                @click="openGameClick(game, gameIndex)"
            >
                <WebpImage
                    v-if="game.icon"
                    :src="game.icon"
                    :alt="`Ikona hry ${game.name}`"
                    css-class="bonusomat-board__modal__game__img"
                />
                <div v-else class="bonusomat-board__modal__game__img bonusomat-board__modal__game__img--no-icon"></div>

                {{ game.name }}
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import useBonusomatData from "../../composables/use-bonusomat-data";
import { BonusomatQuestTask, BonusomatQuestGame } from "../../models/bonusomat-quest-detail";

const { gamesData, openGame } = useBonusomatData();

const emit = defineEmits(["closeModal"]);

const props = defineProps<{
    task: BonusomatQuestTask;
    questName: string;
}>();

BonusomatDatalayer.pushImpressQuestGames(`${props.questName};${props.task.title}`);

const openGameClick = async (game: BonusomatQuestGame, gameIndex: number) => {
    openGame(game.id, game.type);

    BonusomatDatalayer.pushOpenQuestGame(props.task.title, gameIndex + 1);

    emit("closeModal");
};

const activeTaskGames = computed(() => gamesData.value.filter((game) => props.task.games?.includes(game.id)));
</script>
